// Mock data for Junior Torres Real Estate Website

export const siteData = {
  agent: {
    name: "Mazen El-Majzoub",
    title: "",
    tagline: "Redefining Excellence",
    phone: {
      mobile: "(253) 315-9480",
      office: ""
    },
    email: "mazen@contactprp.com",
    license: "",
    location: "Western WA",
    bio: "Mazen's story is one of many places, cultures, and passions. Born in Venezuela to Lebanese parents and raised in Tacoma, Washington from the age of five, he grew up with a deep appreciation for diversity, hard work, and the meaning of a home.\n\nMazen went on to graduate from Seattle University before earning his graduate degree in Molecular and Biomedical Sciences from Florida International University. His years in the medical field taught him things that no real estate course ever could \u2014 the importance of precision, the weight of details that others might overlook, and the understanding that every decision carries real consequences for real people.\n\nHe brought all of that with him into real estate. The same attention to detail that matters in a lab matters when reviewing a contract. The same care he gave to understanding complex problems is what he brings to every transaction. And the same commitment to putting people first is at the heart of everything he does.\n\nWhether you're buying your first home or ready to make your next move, Mazen treats your goals with the seriousness they deserve \u2014 every client, every time."
  },

  services: [
  {
    id: 1,
    title: "BUYING",
    icon: "home",
    description: "Expert guidance in finding your dream home"
  },
  {
    id: 2,
    title: "SELLING",
    icon: "tag",
    description: "Get the highest possible price for your property"
  },
  {
    id: 3,
    title: "FIRST-TIME HOME BUYERS",
    icon: "key",
    description: "Step-by-step guidance through your first home purchase — financing, inspections, and closing."
  },
  {
    id: 4,
    title: "LUXURY HOMES",
    icon: "gem",
    description: "Discreet, high-touch representation for premium listings and high-value buyer searches."
  },
  {
    id: 5,
    title: "INVESTMENT PROPERTY",
    icon: "trending",
    description: "Identify cash-flow and appreciation opportunities across Pierce and King County."
  },
  {
    id: 6,
    title: "VA LOANS & MILITARY RELOCATION",
    icon: "shield",
    description: "JBLM-area specialist. Experienced with VA loan transactions, PCS timelines, and military relocation logistics."
  },
  {
    id: 7,
    title: "NEW CONSTRUCTION",
    icon: "hammer",
    description: "Builder-contract negotiation, upgrade-package review, and independent representation on new builds."
  },
  {
    id: 8,
    title: "HOME STAGING CONSULTATION",
    icon: "sparkles",
    description: "Strategic staging guidance to maximize listing photos, showings, and final sale price."
  },
  {
    id: 9,
    title: "RELOCATION SERVICES",
    icon: "truck",
    description: "Full support for buyers relocating into Western Washington — virtual tours, neighborhood briefings, and timed closings."
  },
  {
    id: 10,
    title: "ADULT FAMILY HOMES",
    icon: "users",
    description: "Specialized representation for buyers and sellers of licensed Adult Family Homes — zoning, licensing, and investor-ready valuations."
  }],


  testimonials: [
  {
    id: 1,
    text: "Mazen went above and beyond to help us look for our forever home! Even though it took us the better part of the last 6 months he stood by us through the whole process.",
    author: "Bailey B. — Bought a Single Family home in 2026 in Black Diamond, WA"
  },
  {
    id: 2,
    text: "From the very beginning Mazen was incredibly responsive, knowledgeable and patient. He took time to understand exactly what we were looking for and helped us navigate the whole home-buying process. He went above and beyond to advocate for us and ensure everything stayed on track through closing. We truly felt supported the entire time and we would highly recommend him to anyone looking to buy or sell a house. He genuinely cares about his clients!",
    author: "Brandon S. — Bought a Single Family home in 2026 in University Place, WA"
  },
  {
    id: 3,
    text: "Mazen was extremely helpful and was there for us throughout the entire process of selling our parent's home. If there were any questions or concerns, he was there to answer them, and if changes were needed, he would promptly address the issue(s) and resolve them to our satisfaction. We listed it at $495k and sold it for $525k! He was very attentive and knowledgeable and just did an outstanding job overall. We would recommend him to anyone who is wanting to sell their home.",
    author: "Ken W. — Sold a Single Family home in 2025 in Gig Harbor, WA"
  },
  {
    id: 4,
    text: "Mazen instantly made us feel at ease — we were brand new to the area but Mazen's eye for detail assured us that we were in good hands. He took the time to get to know us and what we needed to recommend places that would be a good fit for us. He gave us realistic expectations but wasn't afraid to draw a hard line in negotiations when needed. We would highly recommend Mazen to anyone looking for their new home!",
    author: "Michael G. — Bought a Single Family home in 2025 in Puyallup, WA"
  },
  {
    id: 5,
    text: "With his construction background, Mazen was able to see potential problems or give us a thumbs up regarding a home's structure, plumbing and electrical features. We appreciated his honesty and response in communicating. If needed in the future, we would definitely work with Mazen again.",
    author: "Violet C. — Bought a Single Family home in 2024 in Twin Lakes, Federal Way, WA"
  },
  {
    id: 6,
    text: "We first connected with Mazen through Zillow when my husband and I wanted to view a house — and that's how our relationship began. From the very beginning, Mazen was amazing to work with. He was incredibly responsive, flexible with our schedule, and consistently went above and beyond to help us throughout the entire process. We had a concurrent closure, and anyone who's been through one knows they rarely go smoothly. But thanks to Mazen, the entire experience was far less stressful than we expected. He handled everything with incredible professionalism and grace — jumping through countless hoops and doing a lot of extra work behind the scenes to keep things on track. What stood out most was how he made us feel like a priority every step of the way. Whether it was answering late-night questions, scheduling last-minute showings, or providing honest insights, Mazen was always there with unwavering support.",
    author: "Bought a Single Family home in 2025 in Normandy Park, WA"
  },
  {
    id: 7,
    text: "My family and I had the pleasure of working with Mazen as our realtor, and we couldn't be happier with the experience. From start to finish, Mazen was attentive, knowledgeable, and genuinely dedicated to helping us find the perfect home. He listened to our needs, offered invaluable insights about the market, and guided us through each step with patience and expertise. Mazen's responsiveness and attention to detail made us feel confident and well-supported throughout the entire process. Thanks to Mazen's hard work and commitment, we found our dream home, and the entire experience was seamless and stress-free.",
    author: "Bought a Single Family home in 2024 in Seattle, WA"
  },
  {
    id: 8,
    text: "Upon our first meeting with Mazen we felt a connection. He knows the area, has knowledge of contract work, and has many friends and family in all the right places giving him information and resources to share with us. We are first-time home buyers and when making such an investment it's a big deal. Mazen would always ask the right questions, to guide us towards an honest answer about how we feel when considering a home. And this man has an incredible memory! He would refer to our previous thoughts and considerations when thinking of new or old homes. We even had some rough patches dealing with our lender that he helped guide us through. His knowledge and mentorship is what makes him the right man for the job. When we look to buy again we will reach out to him without hesitation.",
    author: "Bought a Single Family home in 2024 in Auburn, WA"
  }],


  navigation: [
  { label: "Home", path: "/" },
  { label: "Properties", path: "/properties" },
  { label: "Services", path: "/services" },
  { label: "Blog", path: "/blog" },
  { label: "About", path: "/about" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "Contact", path: "/contact" }],


  images: {
    heroBackground: "https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1200&q=80",
    agentPhoto: "/images/mazen-hero.jpg",
    consultationPhoto: "https://images.unsplash.com/photo-1616587896595-51352538155b?w=800",
    interiorPhoto: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=1200",
    prpLogo: "/images/prp-logo.png",
    nameLogo: "/images/me-logo.png"
  },

  socialMedia: {
    facebook: "https://www.facebook.com/mazenshomes/",
    instagram: "https://www.instagram.com/mazen.elmajzoub"
  }
};